import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../../images/mg_logo.png';

const FormHeader = ({ title }) => {
  const { t } = useTranslation();

  return (
    <>
      <Link to="/">
        <img src={Logo} alt={t('nav.logoAlt')} className="form-logo" />
      </Link>

      {title && <p className="mg-text-center">{title}</p>}
    </>
  );
};

export default FormHeader;
